import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import TopCampLejeuneLawyersWrapper from "@components/layouts/topCampLejeuneLawyersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function TopCampLejeuneLawyersHome(): ReactElement {
    return (
        <TopCampLejeuneLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Camp Lejeune Application"
                    domain="TopCampLejeuneLawyers.com"
                />
            </div>
        </TopCampLejeuneLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
